// extracted by mini-css-extract-plugin
export default {"mobile":"mobile","item":"f48Sge6M","buttonContent":"ebhP_AlY"};